import {h, Fragment} from "preact"
import { useAppState, InfiniteScroll } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import Loader from "./elements/Loader"
import useSwatches from './useSwatches'

export default function Category() {
    const {
        response: { products },
        loading
    } = useAppState()
    const foundProducts = products && products.total > 0;

    const { swatchData } = useSwatches();

    return (
        <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-w-100">
            {foundProducts && (
                <>
                    <Sidebar />
                    <Toolbar mobile />
                </>
            )}
            <div class="ns-collection-inner-products ns-d-block ns-d-md-inline ns-w-100 ns-border-box">
                {/* {foundProducts ? (
                    <>
                        <SelectedFilters />
                        <Toolbar />
                        <Products />
                        <BottomToolbar />
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )} */}

                {/* To enable InfiniteScroll - comment above block and uncomment below.
                    Don't forget to import InfiniteScroll component. */}
                {foundProducts ? (
                    <>
                        {/* <SelectedFilters /> */}
                        {/* <Toolbar /> */}
                        <InfiniteScroll>
                            <Products swatchData={swatchData}/>
                        </InfiniteScroll>
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )}
            </div>
        </div>
    )
}
